var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDoubleLeft = function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 4.9c-.8-.8-2-.8-2.8 0L15 14.7c-.8.8-.8 2 0 2.8l9.6 9.6c.8.8 2 .8 2.8 0s.8-2 0-2.8L19.2 16l8.2-8.2c1-.7 1-2.1.2-2.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 16 8.2-8.2c.8-.8.8-2 0-2.8s-2-.8-2.8 0l-9.6 9.6c-.8.8-.8 2 0 2.8l9.6 9.6c.8.8 2 .8 2.8 0s.8-2 0-2.8z"
  })));
};
export default SvgChevronDoubleLeft;